import { useEffect, useState } from "react";
import { toaster } from "@/components/ui/toaster";

export default function InternetConnectionChecker() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [hasShownOfflineMessage, setHasShownOfflineMessage] = useState(false);
  const [hasShownOnlineMessage, setHasShownOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (!hasShownOnlineMessage) {
        toaster.create({
          title: "Կապը վերականգնված է",
          description: "Ինտերնետ կապը վերականգնվել է",
          type: "success",
          duration: 10000,
          isClosable: true,
        });
        setHasShownOnlineMessage(true);
        setHasShownOfflineMessage(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      if (!hasShownOfflineMessage) {
        toaster.create({
          title: "Կապը կորցված է",
          description: "Ինտերնետ կապը կորցված է: Ստուգեք ձեր կապը",
          type: "warning",
          duration: 10000,
          isClosable: true,
        });
        setHasShownOfflineMessage(true);
        setHasShownOnlineMessage(false);
      }
    };

    // Add event listeners
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [hasShownOfflineMessage, hasShownOnlineMessage]);

  return null;
}
